import type { FormEvent, ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface FilterBarFormProps {
  onSubmit: () => void
  className?: string
  children: ReactNode
}

export default function FilterBarForm({ onSubmit, className, children }: FilterBarFormProps) {
  const handleSubmit = (event: FormEvent) => {
    event.preventDefault()
    onSubmit()
  }

  return (
    <form onSubmit={handleSubmit} className={cn(className)}>
      {children}
    </form>
  )
}
